import AcceleratorDoc from "../../models/AcceleratorDoc";
import API from "../../models/API";

export { Classify };

/**
 * Classify Document.
 */
class Classify {
  /**
   * Return NULL if Document could not be classified.
   * @returns
   */
  async firstPage(doc: { docUuid: string }): Promise<string[] | null> {
    return await API.get(`/v0/classify/${doc.docUuid}/firstPage`)
      .then((value: Response) => value.json())
      .then((value: any) => {
        if (!Array.isArray(value)) {
          return null;
        }
        // lol
        return value.map((x) => x + "") as string[];
      })
      .then((results) => Array.from(new Set(results).values()))
      .catch((error: string) => {
        console.log(error);
        return null;
      });
  }
}
